import { ActionService } from 'dashboard-services/services';
import { globalActions } from 'primary-components';

import { settingsMyAccountActions } from 'actions/modules/myAccount';

const wildcardQuery = query => `*${query}*`
export default (() => {
  const getQuery = ({ query, groupName }) => {
    let localQuery = ""
    if(groupName) {
      localQuery += `groupName=${groupName}`
    }
    if(groupName && query) {
      localQuery += "&"
    }
    if(query) {
      localQuery += String(query).includes("=") ? query : "name=" + wildcardQuery(query)
    }
    return localQuery || "*";
  }

  const ON_CHANGE = 'ON_CHANGE_DATA_STORAGE_LIST';
  const onChange = ActionService.makeActionCreator(ON_CHANGE, 'value', 'name')

  const getFavoriteDataPreps = () => (_, getState) => getState().myAccountState.settingsState.favoriteDataPreps
  
  const addToFavorites = ({
    id, 
    modifyDate, 
    name, 
    groupName, 
    status,
    updateSettingsCall
  }) => dispatch => {
    const favoriteDataPreps = dispatch(getFavoriteDataPreps()),
          newFavoriteDps = favoriteDataPreps.add({ id, favorite: true, modifyDate, name, groupName, status })
    dispatch(settingsMyAccountActions.changeSetting(newFavoriteDps, 'favoriteDataPreps'))
    updateSettingsCall({ settings: { favoriteDataPreps: JSON.stringify(newFavoriteDps) } })
  }

  const removeFromFavorites = ({ name, groupName, updateSettingsCall }) => dispatch => {
    const favoriteDataPreps = dispatch(getFavoriteDataPreps()),
          newFavoriteDps = favoriteDataPreps.removeByProps({ name, groupName })
    dispatch(settingsMyAccountActions.changeSetting(newFavoriteDps, 'favoriteDataPreps'))
    updateSettingsCall({ settings: { favoriteDataPreps: JSON.stringify(newFavoriteDps) } })
  }

  const deleteDataPrepWithToast = ({ onDeleteCall, name }) => dispatch => {
    dispatch(globalActions.getToastsStore()).info(
      `${name} will be deleted immediately. You can't undo this action.`,
      "Delete data prep",
      {
        withCancel: false,
        confirmText: "Delete",
        confirmAction: () => 
          onDeleteCall()
            .then(() => dispatch(onChange(undefined, "selectedDpVersion")))
            .then(() => dispatch(globalActions.getMessageStore()).success("Data prep has been deleted."))
        ,
      }
    )
  }

  const DP_DETAILS_TABS = {
    DETAILS: "Details",
    HISTORY: "Versions",
    USAGE: "Groups usage"
  }

  return {
    scroll,
    ON_CHANGE,
    onChange,
    addToFavorites,
    removeFromFavorites,
    deleteDataPrepWithToast,
    DP_DETAILS_TABS,
    getQuery
  }
})()